import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WorkoutService, AlertService } from "../../../services";
import { InjuryService } from "../../../services/injury.service ";
import { AmChart, AmChartsService } from "@amcharts/amcharts3-angular";
import { AutoUnsubscribe, Subscription } from "../store";
import { DevelopmentCalendarService } from "../../../services/development-calendar.service ";

@Component({
  selector: "app-development-calendar-player-list",
  templateUrl: "./player-list.component.html",
  styleUrls: ["./player-list.component.css"],
})

@AutoUnsubscribe
export class TeamDevelopmentCalendarPlayersComponent implements OnInit {
  sub: Subscription;
  firstTeamPlayers = [];
  public links: { title: string; url: any; }[] = [];
  teamID: number = 0;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: Ng4LoadingSpinnerService,
    private _service: DevelopmentCalendarService,
    private as: AlertService,
    private AmCharts: AmChartsService
  ) {}

  ngOnInit() {
    this.teamID = +localStorage.getItem("teamId");
    this.loadDevelopmentCalendarPlayersByTeamID(this.teamID);

    this.links = [
      { title: 'SELECT A PLAYER', url: null }
    ];
  }



  loadDevelopmentCalendarPlayersByTeamID(teamID: number) {
    this.spinner.show();
    this._service.loadDevelopmentCalendarPlayersByTeamID(teamID).subscribe(
      (result: any) => {
        console.log("result  => ", result);
        this.firstTeamPlayers = result;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log("Could not load development calendar players");
      }
    );
  }


  showPlayerDevelopmentCalendar(player) {
    this.router.navigate(['/team-development-calendar/player-calendar/'+this.teamID+'/'+player.playerID]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/team-player-list/player-list.component.ts